import React, { useEffect } from 'react';

const ImageLightbox = ({
  isOpen,
  images = [],
  index = 0,
  alt = '',
  onClose,
  onPrev,
  onNext
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
      if (e.key === 'ArrowLeft') onPrev?.();
      if (e.key === 'ArrowRight') onNext?.();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen || !images?.length) return null;

  const src = images[index] || images[0];
  const hasNav = images.length > 1;

  return (
    <div
      className="fixed inset-0 z-[200] bg-black/80 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-5xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute -top-12 right-0 w-10 h-10 inline-flex items-center justify-center rounded-full text-white/90 hover:text-white hover:bg-white/10"
          aria-label="Close"
        >
          <span className="text-2xl leading-none">×</span>
        </button>

        {hasNav && (
          <>
            <button
              type="button"
              onClick={onPrev}
              className="absolute left-0 top-1/2 -translate-y-1/2 px-3 py-2 text-white/90 hover:text-white"
              aria-label="Previous image"
            >
              ‹
            </button>
            <button
              type="button"
              onClick={onNext}
              className="absolute right-0 top-1/2 -translate-y-1/2 px-3 py-2 text-white/90 hover:text-white"
              aria-label="Next image"
            >
              ›
            </button>
          </>
        )}

        <div className="bg-black/20 rounded-lg overflow-hidden">
          <img
            src={src}
            alt={alt}
            className="w-full max-h-[85vh] object-contain bg-black"
          />
        </div>

        {hasNav && (
          <div className="mt-3 text-center text-xs text-white/80">
            {index + 1} / {images.length}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageLightbox;

